export class RoutingUtils {

  /**
   * We need this function to read the pathname from the url bar
   * The angular Router works different and will in AppComponent give '/'
   */
  public static getPath(): string {
    return window.location.pathname;
  }
}
